import { httpClient } from 'core/net/http';
import HttpResponse from 'core/net/HttpResponse';
import Guid from 'core/types/Guid';
import { IAlertPointDataWithMonitor } from '../../modelling-service/types';

export const fetchMonitorData = async (
  monitorIds: Guid[],
  utcDateTime: string,
  selectedSensorGroup: Guid
): Promise<IAlertPointDataWithMonitor[]> => {
  const url = `monitoring/monitor-data`;
  const payload = {
    monitorIds: monitorIds,
    measurementGroupId: selectedSensorGroup,
    utcDateTime,
  };
  const { data, isSuccess }: HttpResponse<IAlertPointDataWithMonitor[] | null> = await httpClient.useInternalApi
    .asAuthorised()
    .post(url, payload);
  if (!isSuccess) throw new Error('Something went wrong when trying to fetch monitor data');
  return data ?? [];
};
